import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const PROXY = process.env.REACT_APP_API_URL + "api";

export const fetchLeadPartners = createAsyncThunk('leadPartner/fetch-lead-partners', async () => {
    const res = await axios.get(`${PROXY}/company/fetch-lead-partners`);
    return res.data.companies;
});

const leadPartnerSlice = createSlice({
    name: 'leadPartner',
    initialState: {
        leadPartners: [],
        status: {
            fetch: 'idle',
        },
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeadPartners.pending, (state) => {
                state.status.fetch = 'loading';
            })
            .addCase(fetchLeadPartners.fulfilled, (state, action) => {
                state.status.fetch = 'succeeded';
                state.leadPartners = action.payload || [];
            })
            .addCase(fetchLeadPartners.rejected, (state, action) => {
                state.status.fetch = 'failed';
                state.error = action.error.message;
            })

    }
});

export default leadPartnerSlice.reducer;